const main = (function(){
	function setup(){
		// Navigation Setup
		navigation();

		// AnchorLink Setup
		anchorlinks.setup();

		// FadeOverlay Setup
		fadeOverlay.setup();

		// Scrollspy
		if(document.querySelector('.scrollspy')) scrollspy();

		// Front Page Video
		if(document.querySelector('#fp_video')) fpVideo();

		// Map + map-accordion
		if(document.querySelector('.ps_content_ref')) vaiMap();

		// Accordions
		if(document.querySelector('.vai-accordion')) vaiAccordion();

		// Send Form
		if(document.querySelector('#vai_form')) vaihingerForm();

	}

	return setup;
})();


/*** EventListeners **/
// Dom Content Loaded
document.addEventListener('DOMContentLoaded',main);

// onPageshow
window.addEventListener('pageshow',()=>{
	fadeOverlay.hide();
	anchorlinks.autoscroll();
});